<template>
  <div class="main_center">
    <div class="content">
      <div class="search-content">
        <div class="mainBtn">
          <el-button @click="routerAdd" size="small"
                     type="primary"
                     v-if="hasBtnPermission('btn_jz_pm_dgwitness_busflow_configs_add')">新增</el-button>
        </div>
        <div class="searchBtn">
          <span class="label-form">关键字搜索：</span>
          <el-input @keyup.enter.native="searchBtn" clearable placeholder="请输入内容搜索" style="width: 200px" v-model="form.search"></el-input>
          <span class="label-form">业务类型：</span>
          <el-select @change="searchBtn" clearable
                     style="width:150px;display: inline-block"
                     v-model="form.busType" value-key="value">
            <el-option :key="index"
                       :label="item.name" :value="item.value"
                       v-for="(item,index) in businessTypeNamelist"></el-option>
          </el-select>
          <el-button @click="searchBtn" size="small" style="margin-left: 12px" type="primary">搜索</el-button>
          <el-button @click="moreSearchItem = true" icon="el-icon-arrow-down" size="mini" type="text">更多搜索</el-button>
          <el-divider direction="vertical"></el-divider>
          <el-button @click="refresh" icon="el-icon-refresh" type="text"></el-button>
        </div>
      </div>
      <el-table :data="tableData" ref="multipleTable"
                :height="tableMaxHeight"
                stripe border
                class="table-content"
                :header-cell-style="this.$globalGrayTableHeaderStyle"
                v-loading="dataListLoading"
                @selection-change="handleSelectionChange">
                <el-table-column fixed type="selection" v-if="hasBtnPermission('btn_jz_pm_dgwitness_busflow_configs_delete')" align="center"
                         :show-overflow-tooltip='true'></el-table-column>
        <el-table-column fixed
                         label="序号"
                         type="index"
                         :index="indexMethod"
                         width="50"
                         align="center"></el-table-column>
        
        <el-table-column fixed="right" label="操作" align="center" width="100">
          <template slot-scope="scope">
            <el-button type="text" title="查看" v-if="hasBtnPermission('btn_jz_pm_dgwitness_busflow_configs_view')" @click="router(scope.row)">查看</el-button>
            <el-button type="text" title="删除" v-if="hasBtnPermission('btn_jz_pm_dgwitness_busflow_configs_delete')" @click="deleteById(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="业务类型" prop='busTypeName' header-align="center" align="center" min-width='90'
                         :show-overflow-tooltip='true'>
          <template slot-scope="scope" >
            <el-tag v-if="scope.row.busType" :type="formatterTagType(scope.row.busType,'projectType')" size="small" :hit="false" effect="plain"  > {{scope.row.busTypeName}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="节点名称"
                         prop='nodeName'
                         header-align="center"
                         align="left"
                         min-width='200'
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="节点编号"
                         prop='nodeCode'
                         header-align="center"
                         align="center"
                         min-width='100'
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="分类节点"
                         prop='classNode'
                         header-align="center"
                         align="center"
                         min-width='120'
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="开启预警" prop='warnEnable' header-align="center" align="center" min-width='80'
                         :show-overflow-tooltip='true'>
          <template slot-scope="scope" >
            <el-tag   size="small" :hit="false" effect="plain" :type="scope.row.warnEnable==0?'danger':'success'"  > {{scope.row.warnEnable==0?"关闭":"开启"}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="受理"
                         prop='enableHandle'
                         header-align="center"
                         align="center" min-width='60'
                         :show-overflow-tooltip='true'>
          <template slot-scope="scope" >
            <el-tag   size="small" :hit="false" effect="plain" :type="scope.row.enableHandle==0?'danger':'success'"  > {{scope.row.enableHandle==0?"否":"是"}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="支持自定义表单" prop='enableCustom' header-align="center" align="center" min-width='120'
                         :show-overflow-tooltip='true'>
          <template slot-scope="scope" >
            <el-tag   size="small" :hit="false" effect="plain" :type="scope.row.enableCustom==0?'danger':'success'"   > {{scope.row.enableCustom==0?"否":"是"}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="数据集编码" prop='datasetCode' header-align="center" align="center" min-width='110'
                         :show-overflow-tooltip='true'></el-table-column>
        <el-table-column label="表单ID" prop='formId' header-align="center" align="center" min-width='160'
                         :show-overflow-tooltip='true'></el-table-column>
      </el-table>
      <el-pagination background
                     layout="total, sizes, prev, pager, next"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="pageSize"
                     :total="total"
                     :current-page="pageIndex"
                     @size-change="sizeChangeHandle"
                     @current-change="currentChangeHandle"></el-pagination>
    </div>
  </div>
</template>

<script>
  import {mapState} from "vuex";


  export default {
  data() {
    return {
      tableMaxHeight: document.documentElement.clientHeight - 227,
      dataListLoading: false,
      form: {
        search:'' ,//搜索框的值
       // classNode: "",
        busType: "",
      },
      businessTypeNamelist: [],
      classNodelist: [],
      moreSearchItem: false,
      checkList1: '',
      pageSize: 10,//每页条数
      pageIndex: 1,//当前页
      total: 0,//总条数
      tableData: [],
      multipleSelection: [],
      user: '', //角色类型
      formData: {}
    }
  },
  computed: {
    ...mapState({
      stateData: state => state.user
    }),
  },
  filters: {
    ellipsis(text, num) {
      if (text.length > num) {
        return text.substring(0, num) + '...';
      } else {
        return text;
      }
    },
  },
  created() {
    this.getDic('jz_dgwitness_bustype');
  },
  activated() {
   // this.user = this.stateData.pageRoleIds //角色类型
    this.getDataList()
    // this.refresh()
  },
  mounted() {
    const that = this;
    let resizeTag = true
    window.onresize = () => {
      if (resizeTag) { //防抖动
        that.ifmove();
        resizeTag = false
        setTimeout(() => {
          resizeTag = true
        }, 1000)
      }
    }
    that.ifmove();
  },
  methods: {
    ifmove() {
      // let hasBtnPermisson = this.hasBtnPermission('btn_jz_pm_dgwitness_busflow_configs_add') || this.hasBtnPermission('btn_jz_pm_dgwitness_busflow_configs_delete');
      let tableMaxHeight = document.documentElement.clientHeight - 227;
      this.pageSize = parseInt((tableMaxHeight) / 50) || 1;
      this.$nextTick(() => {
        this.tableMaxHeight = tableMaxHeight
      })
      // this.getDataList()
    },

    getDataList() { // 获取列表数据
      this.dataListLoading=true;
      this.$httpReq.post('/configs/sysFlowNodeConfig/list', {
        'page': this.pageIndex,
        'rows': this.pageSize,
        'searchKey': this.form.search,
        'filter': this.form
      }).then(res => {
        this.tableData = res.data.rows;
        this.total = res.data.total;
        this.$refs.multipleTable.doLayout();
        this.dataListLoading=false;
      })
    },

    indexMethod(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    searchBtn() { //搜索按钮
      this.pageIndex = 1;
      this.pageSize = 10;
      this.getDataList()
    },
    refresh() {//刷新按钮
      this.pageIndex = 1;
      this.form.search = "";
      this.form.busType = "";
    //  this.form.classNode = "";
      this.getDataList()

    },

    routerAdd(){ //新增
      window.sessionStorage.setItem("addUpdateIndex",2);

      window.sessionStorage.setItem("id", '');

      this.$router.push({
        name:'flownode_config_detail',
        query:{
          id:''
        }
      })

    },

    router(item){ // 跳转详情
      var id = item.id;
      this.$router.push({
        name:'flownode_config_view',
        query:{
          id:id
        }
      })

    },



    deleteById(item) {
      this.$confirm(`确定要删除该数据?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
      this.$httpReq.post('/configs/sysFlowNodeConfig/delete', {
        id: item.id
      }).then(res => {
        if (res.data.code == '1') {
          this.$message({
            type: 'success',
            message: res.data.msg
          })
          this.getDataList();
        } else {
          this.$message({
            type: 'error',
            message: res.data.msg
          })
        }
      })
      })
    },
    deleteSelectItem() {
      let ids = new Array();
      this.multipleSelection.forEach(key => {
        ids.push(key.id)
      })

      if (ids != "" || ids.length > 0) {
        this.$httpReq.post('/configs/sysFlowNodeConfig/delete', {
          idList: ids
        }).then(res => {
          if (res.data.code == '1') {
            this.$message({
              type: 'success',
              message: res.data.msg
            })
            this.getDataList();
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        })
      } else {
        this.$message({
          type: 'error',
          message: "未选择删除项。"
        })
      }

    },

    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1
      this.getDataList()
    },

    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },

    getDic(type) { // 获取字典
      this.$httpReq.get('/sys/dictData/getList?type=' + type).then(res => {
        if (res.data.code === '1') {
          switch (type) {
            case 'jz_dgwitness_bustype':this.businessTypeNamelist = res.data.data;break;
          }
        }
      })
    },

  }


}
</script>

<style lang="scss">
.main_center {
  .top {
    .input_title {
      display: flex;
    }

    .el-form-item {
      margin-bottom: 0;
    }
  }
}

.margin-hide {
  .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>